

























































































































































































import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import DateRange from '@/components/common/DateRange.vue';
import {
  gte, lte, like, or, and, exact,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';
import { FetchPolicy } from 'apollo-client/core/watchQueryOptions';
import { DataPagination } from 'vuetify';
import Draggable from 'vuedraggable';
import DraggableDataTable from '@/components/ApplicationProcessing/DraggableDataTable.vue';
import { TableData } from '@/types/DraggableDataTableTypes';
import { accountingSheet, accountingSheetsListTalendMultiPlatformSingleRequestSupported } from '@/utils/config';
import Axios from 'axios';
import PretensionController from '@/controllers/Pretension';
import { pretensionCountsBySheet, unreadOfTotalCell } from '@/utils/sheetPretensions';
import PlatformsAndSuppliersMixin from '@/mixins/PlatformsAndSuppliersMixin';
import _ from 'lodash';
import moment from 'moment';
import { defaultDateRangePreviousMonthToToday } from '@/utils/localCalendarDate';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave']);

/**
 * Глобальный флаг для класс-компонента: предыдущий маршрут был карточкой листа.
 * Заполняется в `beforeRouteEnter` (где `this` ещё не доступен) и считывается в `created`.
 */
let __cameFromAccountingSheetDetail = false;

@Component({
  components: {
    DraggableDataTable,
    Draggable,
    DateRange,
  },
})
export default class AccountingSheetsList extends mixins(PlatformsAndSuppliersMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'AccountingSheetsList',
  }) readonly localStoragePrefix!: string;

  previewFormData: Record<string, any> | null = null;

  previewFormOptions: Record<string, any[]> | null = null;

  selectedSuppliers: string[] = [];

  defaultPlatform: any = '';

  dates: string[] = [];

  defaultDates: string[] = [];

  idsFilter = '';

  /** Выбранные платформы (несколько значений уходят в API как platformId через запятую). */
  selectedPlatforms: string[] = [];

  /**
   * Список листов загружается только после «Применить фильтры».
   * Пока false — не вызывать Talend list и не реагировать на пагинацию как на серверную.
   */
  filtersWereApplied = false;

  /** Раскрытые группы-статусы. Пустой массив — все свёрнуты; между визитами не сохраняется. */
  openPanels: number[] = [];

  /** Всего листов под фильтром по каждому статусу — для счётчика в заголовке группы. */
  totalItemsByStatus: Record<string, number | null> = {};

  /** Идёт загрузка таблиц после нажатия «Применить фильтры». */
  applyFiltersLoading = false;

  /** Подавляет @Watch при программной установке платформ при загрузке справочника. */
  private silentPlatformsSync = false;

  /**
   * Восстанавливать платформу/поставщиков/id из localStorage только если в URL уже есть период
   * (сохранённая ссылка или переход с явными query-параметрами), а не при обычном открытии страницы.
   */
  restoreFiltersFromBookmarkOrNotification = false;

  /**
   * Идёт восстановление состояния списка после возврата с карточки листа.
   * Пока true — `invalidateSheetsListAfterFilterChange` не очищает таблицы (важно, иначе
   * каскад watcher'ов от dates/suppliers стирает только что восстановленный набор данных).
   */
  private restoringFromDetailSession = false;

  /**
   * Имя поля и записи позиций между переходами list → detail → list строится из префикса.
   * Используется только для tableState; фильтры (даты/платформа/...) живут в URL и localStorage.
   */
  private get appliedListStateSessionKey(): string {
    return `${this.localStoragePrefix}:accounting_sheets_list_applied_state_v2`;
  }

  /**
   * Передаём DateRange `restore-dates-from-local-storage = true` только во время восстановления
   * после возврата с карточки листа: без этого DateRange при первом mount подменит сохранённые
   * даты результатом `defaultDateRangePreviousMonthToToday()`.
   */
  get datesShouldRestoreFromStorage(): boolean {
    return this.restoringFromDetailSession;
  }

  /**
   * Доступные платформы из listing PlantsHR по oo_id из сессии (не объекты PlantsHR в профиле —
   * только то, что возвращает API по правам).
   */
  platformOptionsForFilter: Array<Record<string, any>> = [];

  platformOptionsLoading = false;

  private platformOptionsLoadPromise: Promise<void> | null = null;

  gte = (type: string, value: string) => gte(type, value)

  lte = (type: string, value: string) => lte(type, value)

  get defaultPagination(): DataPagination {
    return _.cloneDeep({
      page: 1,
      pageStart: 0,
      itemsPerPage: 10,
      pageStop: 0,
      pageCount: 0,
      itemsLength: 0,
    });
  }

  tables: Array<TableData> = [
    {
      status: 'supplier_confirmation',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'supplier_changes_approval',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'controlling_approval',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'diadoc_signing_await',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'signed_by_signer',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'accounting_approval',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'payment_await',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'payment_done',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'problem',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'recalled',
      items: [],
      loading: false,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
  ];

  get suppliersFilterVisible(): boolean {
    return !this.isSupplier;
  }

  get headers() {
    const headers = [
      {
        text: this.$t('id'),
        value: 'id',
      },
      {
        text: 'Дата создания',
        value: 'createdAt',
      },
      {
        text: 'Учетный период',
        value: 'accountingPeriod',
      },
      {
        text: 'Платформа',
        value: 'platformName',
      },
      {
        text: this.$t('supplier'),
        value: 'supplierName',
      },
      {
        text: 'Итого без НДС',
        value: 'totalWithoutTax',
      },
    ];
    // Задача 10833: дробь «непрочитанные/всего» по претензиям листа. Координатору претензии закрыты.
    if (this.showPretensionsColumn) {
      headers.push({ text: 'Претензии', value: 'pretensionsCell' });
    }
    if (!this.isSupplier) {
      return headers;
    }
    return headers.filter((h) => h.value !== 'supplierName');
  }

  get showPretensionsColumn(): boolean {
    return !this.isCoordinator;
  }

  /**
   * Как на формировании: неактивна при дефолтных фильтрах и пока список ни разу не подгружали.
   * Дополнительно: пока идёт загрузка таблиц (в т.ч. смена страницы), чтобы не гонять сброс с запросом.
   */
  get resetFiltersDisabled(): boolean {
    if (this.applyFiltersLoading) {
      return true;
    }
    if (this.tables.some((t) => t.loading)) {
      return true;
    }
    if (this.filtersChanged()) {
      return false;
    }
    return !this.filtersWereApplied;
  }

  /** Пока фильтры не применяли или сброшены — одна подсказка вместо блока таблиц. */
  get showApplyFiltersHint(): boolean {
    if (this.filtersWereApplied) {
      return false;
    }
    if (this.applyFiltersLoading) {
      return false;
    }
    if (this.tables.some((t) => t.loading)) {
      return false;
    }
    return !this.tables.some((t) => (t.items?.length ?? 0) > 0);
  }

  beforeRouteEnter(to: any, from: any, next: (cb?: (vm: any) => void) => void) {
    __cameFromAccountingSheetDetail = !!(from && from.name === 'AccountingSheetPage');
    next();
  }

  beforeRouteLeave(to: any, from: any, next: () => void) {
    try {
      if (to && to.name === 'AccountingSheetPage' && this.filtersWereApplied) {
        this.persistAppliedListStateToSession();
      } else {
        this.clearAppliedListStateInSession();
      }
    } catch (e) {
      console.warn('AccountingSheetsList beforeRouteLeave failed', e);
    }
    next();
  }

  created() {
    // Поставщика без supplier_id скоупить нечем — уводим до любых запросов.
    if (this.isSupplier && !this.supplierAutoFilterIds().length) {
      console.error('SUPPLIER user without supplier_id — misconfiguration');
      this.$router.replace({ name: 'AccessDenied' });
      return;
    }

    const cameFromDetail = __cameFromAccountingSheetDetail;
    __cameFromAccountingSheetDetail = false;

    if (cameFromDetail) {
      this.prepareRestoreFromDetailSession();
    } else {
      this.clearAppliedListStateInSession();
    }

    this.restoreFiltersFromBookmarkOrNotification = this.restoringFromDetailSession || !!(
      this.$route.query.dateFrom && this.$route.query.dateTo
    );
    this.calculateDefaultDates();
    this.defaultPlatform = String(this.userPlatformIds[0] || '');
    this.ensurePlatformOptionsLoaded();
    if (this.restoreFiltersFromBookmarkOrNotification) {
      this.idsFilter = this.getFromStorage('ids') || '';
    } else {
      this.idsFilter = '';
    }
  }

  /** Переопределение PlatformsAndSuppliersMixin: не тянуть платформу из прошлой сессии без ссылки с периодом. */
  setSelectedPlatform() {
    const fallback = String(this.userPlatformIds[0] || '');
    if (!this.restoreFiltersFromBookmarkOrNotification) {
      this.selectedPlatform = fallback;
      return;
    }
    let selectedPlatform = '';
    if (typeof window !== 'undefined') {
      selectedPlatform = this.getFromStorage('selected_platform') || '';
    }
    if (Number(selectedPlatform)) {
      this.selectedPlatform = selectedPlatform;
    } else {
      this.selectedPlatform = fallback;
    }
  }

  private ensurePlatformOptionsLoaded(): Promise<void> {
    if (!this.platformOptionsLoadPromise) {
      this.platformOptionsLoadPromise = this.loadPlatformOptionsForFilter();
    }
    return this.platformOptionsLoadPromise;
  }

  /** Список платформ для фильтра: только oo_id из сессии, данные с бэкенда (см. ApplicationActualsList.loadPlatforms). */
  private async loadPlatformOptionsForFilter(): Promise<void> {
    this.platformOptionsLoading = true;
    try {
      if (!this.userPlatformIds?.length) {
        this.platformOptionsForFilter = [];
        return;
      }
      const filterBuilder = new FilterBuilder();
      filterBuilder.addFilters(
        or(...this.userPlatformIds.map((platformId: number) => exact('oo_id', platformId))),
      );
      const rows = await this.loadEntityListing(
        'PlantsHR',
        { filter: filterBuilder.build() },
        'network-only',
        { maxDepth: 1 },
      );
      this.platformOptionsForFilter = rows || [];
    } catch (e) {
      console.error(e);
      this.platformOptionsForFilter = [];
    } finally {
      this.platformOptionsLoading = false;
    }
  }

  /** Допустимые id платформ: из ответа listing; если запрос ещё пуст — временно по userPlatformIds из сессии. */
  private get allowedPlatformIds(): Set<string> {
    const fromApi = (this.platformOptionsForFilter || []).map((p) => String(p.id));
    if (fromApi.length > 0) {
      return new Set(fromApi);
    }
    return new Set(this.userPlatformIds.map(String));
  }

  /** Пустой массив для всех ролей кроме поставщика. */
  supplierAutoFilterIds(): string[] {
    if (!this.isSupplier) {
      return [];
    }
    const supplierId = this.pimcoreUser?.supplier_id;
    if (supplierId === null || supplierId === undefined || supplierId === '') {
      return [];
    }
    return [String(supplierId)];
  }

  /** Вызывается после каждого места, где selectedSuppliers мог быть перезаписан. */
  enforceSupplierAutoFilter(): void {
    if (!this.isSupplier) {
      return;
    }
    this.selectedSuppliers = this.supplierAutoFilterIds();
  }

  /** Поставщики по объединению выбранных платформ (как в mixin, но для нескольких oo_id). */
  async loadSuppliers(rules?: TypeExtractionRules, fetchPolicy: FetchPolicy = 'cache-first') {
    // Справочник поставщиков поставщику не нужен: выбор зафиксирован его собственным id.
    if (this.isSupplier) {
      this.suppliers = [];
      this.suppliersIsLoading = false;
      return [];
    }
    if (!this.selectedPlatforms?.length) {
      this.suppliers = [];
      this.suppliersIsLoading = false;
      return [];
    }
    this.suppliersIsLoading = true;
    const filterBuilder = new FilterBuilder();
    if (this.selectedPlatforms.length === 1) {
      filterBuilder.addFilters(
        and(
          like('PlantsHR', `%${this.selectedPlatforms[0]}%`),
        ),
      );
    } else {
      filterBuilder.addFilters(
        or(...this.selectedPlatforms.map((id) => like('PlantsHR', `%${id}%`))),
      );
    }
    try {
      this.suppliers = await this.loadEntityListing('Supplier', {
        filter: filterBuilder.build(),
      }, fetchPolicy, rules);
    } catch (e) {
      console.error(e);
      this.suppliers = [];
    }
    this.suppliersIsLoading = false;
    return this.suppliers;
  }

  /**
   * При восстановлении после возврата с карточки листа берём список платформ напрямую из снимка
   * sessionStorage: миксин в `selectedPlatformChanged` уже мог перезаписать `localStorage[selected_platform]`
   * скалярным id, и CSV выбранных платформ был бы потерян.
   */
  private snapshotSelectedPlatformIds(): string[] | null {
    if (!this.restoringFromDetailSession) {
      return null;
    }
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return null;
    }
    const raw = window.sessionStorage.getItem(this.appliedListStateSessionKey);
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw) as { selectedPlatforms?: unknown };
      if (!Array.isArray(parsed?.selectedPlatforms)) {
        return null;
      }
      return parsed.selectedPlatforms.map((id) => String(id)).filter((id) => id !== '');
    } catch (e) {
      console.warn('Failed to read snapshot selected platforms', e);
      return null;
    }
  }

  private initSelectedPlatformsFromStorage() {
    const allowed = this.allowedPlatformIds;
    const take = (ids: string[]) => {
      const next = [...new Set(ids.map((id) => String(id)).filter((id) => allowed.has(id)))];
      this.selectedPlatforms = next;
    };
    const firstAllowed = this.platformOptionsForFilter[0]?.id ?? this.userPlatformIds[0];

    const fromSnapshot = this.snapshotSelectedPlatformIds();
    if (fromSnapshot) {
      take(fromSnapshot);
      this.setToStorage('selected_platform', this.selectedPlatforms.join(','));
      if (!this.selectedPlatforms.length && firstAllowed !== undefined && firstAllowed !== null && firstAllowed !== '') {
        take([String(firstAllowed)]);
      }
      return;
    }

    if (!this.restoreFiltersFromBookmarkOrNotification) {
      if (firstAllowed !== undefined && firstAllowed !== null && firstAllowed !== '') {
        take([String(firstAllowed)]);
      }
      return;
    }
    let raw = '';
    if (typeof window !== 'undefined') {
      raw = (this.getFromStorage('selected_platform') || '').trim();
    }
    if (raw.includes(',')) {
      take(raw.split(',').map((s) => s.trim()).filter(Boolean));
    } else if (raw && Number(raw)) {
      take([raw]);
    } else {
      this.selectedPlatforms = [];
    }
    if (!this.selectedPlatforms.length && firstAllowed !== undefined && firstAllowed !== null && firstAllowed !== '') {
      take([String(firstAllowed)]);
    }
  }

  calculateDefaultDates() {
    this.defaultDates = defaultDateRangePreviousMonthToToday();
  }

  beforeDestroy() {
    this.$bus.$off('preview');
  }

  private clearAppliedListStateInSession() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem(this.appliedListStateSessionKey);
    }
  }

  /**
   * Полный снимок состояния списка для возврата с карточки листа: фильтры + items + pagination.
   * Сохраняется в `beforeRouteLeave`, только если `to` — `AccountingSheetPage` и фильтры применены.
   */
  private persistAppliedListStateToSession() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }
    const payload = {
      dates: this.dates,
      idsFilter: this.idsFilter,
      selectedPlatforms: this.selectedPlatforms,
      selectedSuppliers: this.selectedSuppliers,
      filtersWereApplied: this.filtersWereApplied,
      tables: this.tables.map((t: TableData) => ({
        status: t.status,
        items: Array.isArray(t.items) ? t.items : [],
        pagination: _.cloneDeep(t.pagination || this.defaultPagination),
      })),
    };
    try {
      window.sessionStorage.setItem(
        this.appliedListStateSessionKey,
        JSON.stringify(payload),
      );
      if (Array.isArray(this.dates) && this.dates.length === 2) {
        this.setToStorage('date_from', this.dates[0]);
        this.setToStorage('date_to', this.dates[1]);
      }
    } catch (e) {
      console.warn('Failed to save accounting sheets list applied state', e);
    }
  }

  /**
   * Готовим состояние перед циклом инициализации платформ: проставляем флаг `restoringFromDetailSession`,
   * заранее заносим выбранные платформы/поставщиков/id в localStorage, чтобы существующий поток
   * `afterLoadingPlatforms` → `initSelectedPlatformsFromStorage` корректно их подхватил.
   */
  private prepareRestoreFromDetailSession() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }
    const raw = window.sessionStorage.getItem(this.appliedListStateSessionKey);
    if (!raw) {
      return;
    }
    try {
      const parsed = JSON.parse(raw) as {
        dates?: unknown;
        idsFilter?: unknown;
        selectedPlatforms?: unknown;
        selectedSuppliers?: unknown;
        filtersWereApplied?: unknown;
        tables?: unknown;
      };
      const dateList = Array.isArray(parsed?.dates)
        ? parsed.dates.map((d) => String(d)).filter(Boolean)
        : [];
      const platformIds = Array.isArray(parsed?.selectedPlatforms)
        ? parsed.selectedPlatforms.map((id) => String(id)).filter(Boolean)
        : [];
      const supplierIds = Array.isArray(parsed?.selectedSuppliers)
        ? parsed.selectedSuppliers.map((id) => String(id)).filter(Boolean)
        : [];
      if (!parsed?.filtersWereApplied || dateList.length !== 2 || platformIds.length === 0) {
        this.clearAppliedListStateInSession();
        return;
      }
      this.restoringFromDetailSession = true;
      this.setToStorage('selected_platform', platformIds.join(','));
      this.setToStorage('suppliers', supplierIds.join(','));
      this.setToStorage('date_from', dateList[0]);
      this.setToStorage('date_to', dateList[1]);
      const idsValue = typeof parsed?.idsFilter === 'string' ? parsed.idsFilter : '';
      this.setToStorage('ids', idsValue);
    } catch (e) {
      console.warn('Failed to parse accounting sheets list applied state', e);
      this.clearAppliedListStateInSession();
      this.restoringFromDetailSession = false;
    }
  }

  /**
   * Завершение восстановления: после того как платформы/поставщики/даты подхвачены из storage,
   * подменяем содержимое таблиц и пагинацию ровно тем, что было до перехода в карточку листа.
   * Сетевые запросы не выполняем — пользователь видит ту же страницу, что и до клика.
   *
   * Флаг `restoringFromDetailSession` НЕ сбрасывается здесь: его снимает caller после `$nextTick`,
   * чтобы отложенные watcher'ы (`selectedSuppliers`, `dates`) увидели его как `true` и не вызвали
   * `invalidateSheetsListAfterFilterChange`, который иначе сотрёт только что восстановленный снимок.
   */
  private finalizeRestoreFromDetailSession() {
    if (!this.restoringFromDetailSession) {
      return;
    }
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return;
    }
    const raw = window.sessionStorage.getItem(this.appliedListStateSessionKey);
    if (!raw) {
      return;
    }
    try {
      const parsed = JSON.parse(raw) as { tables?: unknown };
      const savedTables = Array.isArray(parsed?.tables) ? parsed.tables : [];
      const byStatus = new Map<string, { items: any[]; pagination: DataPagination }>();
      savedTables.forEach((entry: any) => {
        if (entry && typeof entry.status === 'string') {
          byStatus.set(String(entry.status), {
            items: Array.isArray(entry.items) ? entry.items : [],
            pagination: entry.pagination as DataPagination,
          });
        }
      });
      this.tables.forEach((t: TableData, index: number) => {
        const saved = byStatus.get(t.status);
        if (!saved) {
          return;
        }
        this.$set(this.tables, index, {
          ...t,
          items: saved.items,
          loading: false,
          pagination: _.cloneDeep(saved.pagination || this.defaultPagination),
        });
      });
      this.filtersWereApplied = true;
      // Строки вернулись без запроса, а счётчик претензий за время в карточке мог смениться:
      // человек открыл претензию. Перезапрашиваем только его.
      this.tables.forEach((table: TableData) => {
        this.fillPretensionCells(table);
      });
    } catch (e) {
      console.warn('Failed to restore accounting sheets list tables', e);
    }
  }

  /**
   * Дать отложенным watcher'ам отработать «через флаг» и только потом снять его —
   * иначе `selectedSuppliersChanged` / `datesChanged`, поставленные в очередь во время
   * `afterLoadingPlatforms`, в свою микротаску снова обнулят таблицы и `filtersWereApplied`.
   */
  private async releaseDetailRestoreFlagAfterFlush() {
    if (!this.restoringFromDetailSession) {
      return;
    }
    await this.$nextTick();
    await this.$nextTick();
    this.restoringFromDetailSession = false;
  }

  /** Сброс страницы: при клиентской пагинации (несколько платформ) старый page > max давал пустой slice. */
  private resetAllTablesPaginationFirstPage() {
    this.tables.forEach((t: TableData) => {
      if (t.pagination) {
        t.pagination.page = 1;
        t.pagination.pageStart = 0;
      }
    });
  }

  /**
   * Черновик фильтра изменён — снять признак «применено» и очистить все таблицы без запроса к API.
   * Сбрасывает индикатор «Применить», чтобы не показывать загрузку после устаревшего запроса.
   * Во время восстановления состояния после возврата с карточки листа метод не очищает данные,
   * иначе каскад watcher'ов (dates/suppliers/platforms) сотрёт только что поднятый снимок.
   */
  private invalidateSheetsListAfterFilterChange() {
    if (this.restoringFromDetailSession) {
      return;
    }
    this.applyFiltersLoading = false;
    this.filtersWereApplied = false;
    this.openPanels = [];
    this.totalItemsByStatus = {};
    this.tables.forEach((t: TableData, index: number) => {
      this.$set(this.tables, index, {
        ...t,
        items: [],
        loading: false,
        pagination: _.cloneDeep(this.defaultPagination),
      });
    });
  }

  onIdsFilterInput(value: string) {
    this.setToStorage('ids', value);
    this.invalidateSheetsListAfterFilterChange();
  }

  validateApplyFilters(): boolean {
    const datesOk = Array.isArray(this.dates) && this.dates.length === 2;
    const platformOk = (this.selectedPlatforms?.length ?? 0) > 0;
    return datesOk && platformOk;
  }

  async applyFilters() {
    if (this.applyFiltersLoading) {
      return;
    }
    if (!this.validateApplyFilters()) {
      return;
    }
    this.applyFiltersLoading = true;
    try {
      this.filtersWereApplied = true;
      await this.reloadTables();
    } catch (e) {
      console.error(e);
      this.filtersWereApplied = false;
      this.invalidateSheetsListAfterFilterChange();
    } finally {
      this.applyFiltersLoading = false;
    }
  }

  async reloadTables() {
    if (!this.filtersWereApplied) {
      return;
    }
    let anyRequestFailed = false;
    let firstErrorDetail = '';
    for (let i = 0; i < this.tables.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const { failed, errorMessage } = await this.reloadTable(this.tables[i]);
      if (failed) {
        anyRequestFailed = true;
        if (!firstErrorDetail && errorMessage) {
          firstErrorDetail = errorMessage;
        }
      }
    }
    if (anyRequestFailed) {
      const base = 'Не удалось загрузить часть списков листов учёта. Проверьте соединение и попробуйте снова.';
      const text = firstErrorDetail ? `${base} ${firstErrorDetail}` : base;
      this.$bus.$emit(
        'notification',
        text,
        'error',
      );
    }
  }

  /** @returns failed — запрос к API завершился ошибкой; errorMessage — для уведомления. */
  async reloadTable(table: TableData): Promise<{ failed: boolean; errorMessage?: string }> {
    if (!this.filtersWereApplied) {
      return { failed: false };
    }
    const currentIndex = this.tables.findIndex((v: TableData) => v.status === table.status);
    this.tables[currentIndex].loading = true;
    const currentTable = this.tables[currentIndex];
    currentTable.pagination = table.pagination || this.defaultPagination;
    const status = table.status.split(',').map((item) => item.trim()).join(',');
    const {
      items,
      totalItems,
      clientSideTotal,
      correctedPage,
      requestFailed,
      errorMessage,
    } = await this.loadAccountingSheets(
      status,
      currentTable.pagination,
    );
    currentTable.items = items;
    this.fillPretensionCells(currentTable);
    if (correctedPage !== undefined) {
      currentTable.pagination.page = correctedPage;
      currentTable.pagination.pageStart = (correctedPage - 1) * currentTable.pagination.itemsPerPage;
    }
    const resolvedTotalItems = clientSideTotal !== undefined ? clientSideTotal : (totalItems ?? null);
    this.$set(this.totalItemsByStatus, currentTable.status, resolvedTotalItems);
    if (resolvedTotalItems !== null) {
      currentTable.pagination.itemsLength = resolvedTotalItems;
    } else {
      const itemsCount = currentTable.pagination.itemsPerPage * (currentTable.pagination.page - 1);
      const ipp = currentTable.pagination.itemsPerPage;
      const fullPage = currentTable.items.length === ipp;
      currentTable.pagination.itemsLength = fullPage
        ? itemsCount + ipp * 2
        : itemsCount + currentTable.items.length;
    }
    currentTable.loading = false;
    this.$set(this.tables, currentIndex, currentTable);
    return {
      failed: !!requestFailed,
      errorMessage: requestFailed ? errorMessage : undefined,
    };
  }

  private resolvePlatformDisplayName(platformId: string): string {
    if (!platformId) {
      return '-';
    }
    const row = (this.platformOptionsForFilter || []).find(
      (p) => String(p.id) === platformId,
    );
    const name = row?.name;
    return name != null && String(name).trim() !== '' ? String(name) : platformId;
  }

  /** Платформа строки: из мульти-запроса, полей ответа API или единственного выбранного фильтра. */
  private inferSheetPlatformId(item: any): string {
    const fromRow = item?._sheetPlatformId ?? item?.platformId ?? item?.platform_id
      ?? item?.platform__id ?? item?.platform?.id ?? item?.platform?.oo_id;
    if (fromRow != null && fromRow !== '') {
      return String(fromRow);
    }
    if (this.selectedPlatforms?.length === 1) {
      return String(this.selectedPlatforms[0]);
    }
    return '';
  }

  addingAttributesToAccountingSheets(lists: any[]): any[] {
    lists.forEach((item) => {
      try {
        const from = this.formatDate(item.startDate);
        const to = this.formatDate(item.finishDate);
        const total = item.totalWithoutTax;
        const totalFmt = total != null && total !== ''
          ? this.$n(Number(total), 'decimal')
          : this.$n(0, 'decimal');
        const hasId = item.id != null && item.id !== '';
        const platformId = hasId ? this.inferSheetPlatformId(item) : '';
        Object.assign(item, {
          accountingPeriod: `${from} - ${to}`,
          totalWithoutTax: totalFmt,
          platformName: hasId ? this.resolvePlatformDisplayName(platformId) : '',
          // Заполнит отдельный запрос претензий; ключ нужен заранее, чтобы ячейка была реактивной.
          pretensionsCell: '',
        });
      } catch (e) {
        console.warn('addingAttributesToAccountingSheets', item?.id, e);
        Object.assign(item, {
          accountingPeriod: '-',
          totalWithoutTax: '',
          platformName: '',
          pretensionsCell: '',
        });
      }
    });
    return lists;
  }

  formatDate(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const m = moment(String(value));
    return m.isValid() ? m.format('DD.MM.YYYY') : '';
  }

  /** Совпадает с ограничением Talend GetAccountingSheetList (pageSize > 20 → 20). */
  private static readonly ACCOUNTING_SHEET_LIST_FETCH_PAGE_SIZE = 20;

  /** Talend/шлюз иногда отвечает 404 вместо пустого списка — не считаем это сбоем загрузки. */
  /**
   * Строки листов из ответа списка — понимает обе формы ответа.
   *
   * Talend-джоб `get-accounting-sheet-list` отдавал голый массив; python-коннектор
   * (задача 10153) отдаёт `{"totalItems": N, "items": [...]}`, потому что счётчик
   * строк под фильтром из массива страницы не выводится. Оба варианта читаются
   * здесь, чтобы адрес эндпоинта можно было переключить и откатить отдельно от
   * остального кода страницы.
   */
  private static sheetRowsFromResponse(data: unknown): any[] {
    if (Array.isArray(data)) {
      return data;
    }
    const items = (data as { items?: unknown })?.items;
    return Array.isArray(items) ? items : [];
  }

  /**
   * Всего листов под фильтром — `totalItems` верхнего уровня ответа (у самих листов есть
   * своё поле `total`, это сумма с НДС). Приходит только при `includeTotals=1`, старая
   * Talend-форма количества не несёт — тогда null, и счётчик группы не показывается.
   */
  private static sheetTotalItemsFromResponse(data: unknown): number | null {
    if (data === null || typeof data !== 'object' || Array.isArray(data)) {
      return null;
    }
    const totalItems = (data as { totalItems?: unknown }).totalItems;
    if (typeof totalItems !== 'number' || !Number.isFinite(totalItems) || totalItems < 0) {
      return null;
    }
    return totalItems;
  }

  private static isNotFoundHttpError(e: unknown): boolean {
    if (e == null || typeof e !== 'object') {
      return false;
    }
    const status = (e as { response?: { status?: number } }).response?.status;
    return status === 404;
  }

  /** Краткий системный текст для всплывающего уведомления (axios и прочие ошибки). */
  private static formatHttpErrorForNotification(e: unknown): string {
    if (e == null) {
      return '';
    }
    if (typeof e === 'string') {
      return e.length > 400 ? `${e.slice(0, 400)}…` : e;
    }
    const err = e as {
      message?: string;
      response?: { status?: number; statusText?: string; data?: unknown };
    };
    const parts: string[] = [];
    if (err.response?.status != null) {
      parts.push(`HTTP ${err.response.status}`);
    }
    if (err.response?.statusText) {
      parts.push(String(err.response.statusText));
    }
    if (err.response?.data != null) {
      const d = err.response.data;
      const s = typeof d === 'string' ? d : JSON.stringify(d);
      parts.push(s.length > 220 ? `${s.slice(0, 220)}…` : s);
    } else if (err.message) {
      parts.push(err.message);
    }
    if (parts.length === 0) {
      try {
        return String(e).slice(0, 400);
      } catch {
        return 'Неизвестная ошибка';
      }
    }
    const out = parts.join('. ');
    return out.length > 500 ? `${out.slice(0, 500)}…` : out;
  }

  private mergeSheetsFromPlatforms(rowsByPlatform: any[][]): any[] {
    const byId = new Map<string, any>();
    rowsByPlatform.forEach((rows) => {
      rows.forEach((row) => {
        if (row && row.id != null) {
          const pid = row._sheetPlatformId != null && row._sheetPlatformId !== ''
            ? String(row._sheetPlatformId)
            : '';
          const key = pid ? `${row.id}:${pid}` : String(row.id);
          byId.set(key, row);
        }
      });
    });
    return [...byId.values()].sort((a, b) => Number(b.id) - Number(a.id));
  }

  /** Все страницы списка для одной платформы и статуса (для режима без multi-platform в одном запросе). */
  private async fetchAllAccountingSheetsForPlatform(
    platformId: string,
    status: string,
  ): Promise<any[]> {
    const url = accountingSheet.accountingSheetList;
    const pageSize = AccountingSheetsList.ACCOUNTING_SHEET_LIST_FETCH_PAGE_SIZE;
    const all: any[] = [];
    let pageFrom = 0;
    for (;;) {
      const params: Record<string, string | number> = {
        ids: this.idsFilter,
        dateFrom: this.dates[0],
        dateTo: this.dates[1],
        platformId,
        pageFrom,
        pageSize,
        status,
      };
      if (this.selectedSuppliers?.length) {
        Object.assign(params, {
          suppliers: this.selectedSuppliers.join(','),
        });
      }
      let batch: any[];
      try {
        // eslint-disable-next-line no-await-in-loop
        const res = await Axios.get(url, { params });
        batch = AccountingSheetsList.sheetRowsFromResponse(res?.data);
      } catch (e) {
        if (AccountingSheetsList.isNotFoundHttpError(e)) {
          break;
        }
        throw e;
      }
      all.push(...batch.map((row: any) => ({ ...row, _sheetPlatformId: platformId })));
      if (batch.length < pageSize) {
        break;
      }
      pageFrom += pageSize;
    }
    return all;
  }

  async loadAccountingSheets(
    status: string,
    pagination: DataPagination,
  ): Promise<{
    items: any[];
    totalItems?: number | null;
    clientSideTotal?: number;
    correctedPage?: number;
    requestFailed?: boolean;
    errorMessage?: string;
  }> {
    if (!this.selectedPlatforms?.length || !this.dates?.[0] || !this.dates?.[1]) {
      return { items: [] };
    }
    const { page, itemsPerPage } = pagination;
    const url = accountingSheet.accountingSheetList;

    const useMultiRequest = !accountingSheetsListTalendMultiPlatformSingleRequestSupported
      && this.selectedPlatforms.length > 1;

    if (useMultiRequest) {
      try {
        const settled = await Promise.allSettled(
          this.selectedPlatforms.map((pid) => this.fetchAllAccountingSheetsForPlatform(pid, status)),
        );
        const perPlatform: any[][] = [];
        settled.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            perPlatform.push(result.value);
          } else {
            console.error(
              'Accounting sheet list: platform fetch failed',
              this.selectedPlatforms[index],
              status,
              result.reason,
            );
            perPlatform.push([]);
          }
        });
        const merged = this.mergeSheetsFromPlatforms(perPlatform);
        const anyRejected = settled.some((r) => r.status === 'rejected');
        const firstRejected = settled.find((r): r is PromiseRejectedResult => r.status === 'rejected');
        const ipp = Math.max(1, itemsPerPage || 10);
        const maxPage = Math.max(1, Math.ceil(merged.length / ipp) || 1);
        const effectivePage = Math.min(Math.max(1, page), maxPage);
        const start = (effectivePage - 1) * ipp;
        const slice = merged.slice(start, start + ipp);
        return {
          items: this.addingAttributesToAccountingSheets(slice),
          clientSideTotal: merged.length,
          correctedPage: effectivePage !== page ? effectivePage : undefined,
          requestFailed: anyRejected,
          errorMessage: anyRejected && firstRejected
            ? AccountingSheetsList.formatHttpErrorForNotification(firstRejected.reason)
            : undefined,
        };
      } catch (e) {
        if (AccountingSheetsList.isNotFoundHttpError(e)) {
          return { items: [] };
        }
        console.error(e);
        return {
          items: [],
          requestFailed: true,
          errorMessage: AccountingSheetsList.formatHttpErrorForNotification(e),
        };
      }
    }

    const params = {
      ids: this.idsFilter,
      dateFrom: this.dates[0],
      dateTo: this.dates[1],
      platformId: this.selectedPlatforms.length ? this.selectedPlatforms.join(',') : '',
      pageFrom: (page - 1) * itemsPerPage,
      pageSize: itemsPerPage,
      status,
      includeTotals: 1,
    };
    if (this.selectedSuppliers?.length) {
      Object.assign(params, {
        suppliers: this.selectedSuppliers.join(','),
      });
    }
    try {
      const res = await Axios.get(url, {
        params,
      });
      const rows = AccountingSheetsList.sheetRowsFromResponse(res?.data);
      const totalItems = AccountingSheetsList.sheetTotalItemsFromResponse(res?.data);
      if (rows.length) {
        return { items: this.addingAttributesToAccountingSheets(rows), totalItems };
      }
      return { items: [], totalItems };
    } catch (e) {
      if (AccountingSheetsList.isNotFoundHttpError(e)) {
        return { items: [], totalItems: 0 };
      }
      console.error(e);
      return {
        items: [],
        requestFailed: true,
        errorMessage: AccountingSheetsList.formatHttpErrorForNotification(e),
      };
    }
  }

  /**
   * «Претензии» — непрочитанные/всего по выпущенным претензиям листов таблицы (задача 10833).
   * Один запрос на таблицу; сбой оставляет ячейки пустыми и список листов не роняет.
   */
  async fillPretensionCells(table: TableData): Promise<void> {
    const items = Array.isArray(table.items) ? table.items : [];
    const sheetIds = items.map((item: any) => Number(item.id)).filter((id: number) => Number.isInteger(id) && id > 0);
    if (!this.showPretensionsColumn || !sheetIds.length) {
      return;
    }
    try {
      const response = await PretensionController.list({
        sheetIds,
        pageFrom: 0,
        pageSize: AccountingSheetsList.PRETENSIONS_OF_PAGE_LIMIT,
      });
      const [error, result] = response.result;
      if (error || !Array.isArray(result?.data)) {
        console.error('Accounting sheet list: pretension counters failed', error);
        return;
      }
      const counts = pretensionCountsBySheet(result.data, sheetIds);
      items.forEach((item: any) => {
        const count = counts[Number(item.id)];
        this.$set(item, 'pretensionsCell', count ? unreadOfTotalCell(count.unread, count.total) : '');
      });
    } catch (e) {
      console.error(e);
    }
  }

  // ponytail: 100 претензий на страницу до 20 листов; на проде у листа до трёх претензий.
  // Упрёмся — считать претензии по листам на сервере.
  private static readonly PRETENSIONS_OF_PAGE_LIMIT = 100;

  groupTitle(table: TableData): string {
    return table.status === 'payment_await' ? 'Отправлено в ERP' : String(this.$t(table.status));
  }

  /** Пустая строка, пока группа грузится или количество неизвестно. */
  groupCount(table: TableData): string {
    if (table.loading) {
      return '';
    }
    const totalItems = this.totalItemsByStatus[table.status];
    return typeof totalItems === 'number' ? String(totalItems) : '';
  }

  get allGroupsExpanded(): boolean {
    return this.openPanels.length === this.tables.length;
  }

  get toggleAllGroupsLabel(): string {
    return this.allGroupsExpanded ? 'Свернуть все' : 'Раскрыть все';
  }

  toggleAllGroups() {
    this.openPanels = this.allGroupsExpanded ? [] : this.tables.map((_table, index) => index);
  }

  async onPagination(pagination: DataPagination, table: TableData) {
    if (!this.filtersWereApplied) {
      return;
    }
    if (!this.dates?.length || !this.selectedPlatforms?.length) {
      return;
    }
    if (pagination.itemsPerPage === table?.pagination?.itemsPerPage && pagination.pageStart === table?.pagination?.pageStart) {
      return;
    }
    table.loading = true;
    table.pagination = pagination;
    const { failed, errorMessage } = await this.reloadTable(table);
    table.loading = false;
    if (failed) {
      const base = 'Не удалось загрузить страницу списка. Проверьте соединение и попробуйте снова.';
      const text = errorMessage ? `${base} ${errorMessage}` : base;
      this.$bus.$emit(
        'notification',
        text,
        'error',
      );
    }
  }

  move(item: any, to: TableData) {
    console.log('move', item, to);
  }

  async dragChange(event: any, table: TableData) {
    // send request to move item to next status
    // on successful status change or fail - reload both tables
    console.log('change', event, table);
  }

  clickRow(event: any) {
    if (event?.id) {
      this.$router.push({ name: 'AccountingSheetPage', params: { id: event.id } });
    }
  }

  async afterLoadSuppliers(meta?: { platformSwitched?: boolean }) {
    if (!meta?.platformSwitched) {
      return;
    }
    if (this.isSupplier) {
      this.enforceSupplierAutoFilter();
    } else if (this.selectedSuppliers?.length) {
      this.selectedSuppliers = [];
    }
    this.invalidateSheetsListAfterFilterChange();
  }

  async afterLoadingPlatforms() {
    /* DateRange монтируется после immediate-watch mixin; без nextTick даты ещё пустые. */
    await this.$nextTick();
    await this.ensurePlatformOptionsLoaded();
    this.defaultPlatform = String(
      this.platformOptionsForFilter[0]?.id ?? this.userPlatformIds[0] ?? '',
    );
    this.silentPlatformsSync = true;
    try {
      this.initSelectedPlatformsFromStorage();
      this.setToStorage('selected_platform', this.selectedPlatforms.join(','));
      await this.loadSuppliers({ maxDepth: 1 });
      if (this.isSupplier) {
        this.enforceSupplierAutoFilter();
      } else if (this.selectedPlatforms.length) {
        this.selectedSuppliers = this.getFromStorage('suppliers')
          .split(',')
          .filter((supplierId) => supplierId.trim() !== '');
      }
    } finally {
      this.silentPlatformsSync = false;
    }
    this.invalidateSheetsListAfterFilterChange();
    this.finalizeRestoreFromDetailSession();
    await this.releaseDetailRestoreFlagAfterFlush();
  }

  @Watch('selectedPlatforms')
  async selectedPlatformsChanged() {
    if (this.silentPlatformsSync || this.restoringFromDetailSession) {
      return;
    }
    const normalized = this.selectedPlatforms.map((id) => String(id));
    const needsNormalize = this.selectedPlatforms.some(
      (id, i) => id !== normalized[i],
    );
    if (needsNormalize) {
      this.silentPlatformsSync = true;
      this.selectedPlatforms = normalized;
      this.silentPlatformsSync = false;
      this.invalidateSheetsListAfterFilterChange();
      return;
    }
    this.resetAllTablesPaginationFirstPage();
    this.setToStorage('selected_platform', this.selectedPlatforms.join(','));
    await this.loadSuppliers({ maxDepth: 1 });
    await this.afterLoadSuppliers();
    this.invalidateSheetsListAfterFilterChange();
  }

  @Watch('selectedSuppliers')
  async selectedSuppliersChanged() {
    if (this.restoringFromDetailSession) {
      this.setToStorage('suppliers', this.selectedSuppliers.join(','));
      return;
    }
    this.setToStorage('suppliers', this.selectedSuppliers.join(','));
    this.invalidateSheetsListAfterFilterChange();
  }

  @Watch('dates')
  async datesChanged(newVal: string[], oldVal: string[] | undefined) {
    if (this.restoringFromDetailSession) {
      return;
    }
    if (!newVal || newVal.length !== 2) {
      this.invalidateSheetsListAfterFilterChange();
      return;
    }
    const changed = !oldVal || oldVal.length !== 2
      || oldVal[0] !== newVal[0] || oldVal[1] !== newVal[1];
    if (!changed) {
      return;
    }
    this.invalidateSheetsListAfterFilterChange();
  }

  filtersChanged(): boolean {
    const platformsAtDefault = this.selectedPlatforms.length === 1
      && String(this.selectedPlatforms[0]) === String(this.defaultPlatform);
    // У поставщика selectedSuppliers всегда заполнен авто-фильтром — это не
    // пользовательское изменение и не должно разблокировать «Сбросить фильтры».
    return (!this.isSupplier && this.selectedSuppliers.length > 0)
      || !platformsAtDefault
      || this.idsFilter !== ''
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  /** Все доступные платформы уже выбраны — кнопка «Выбрать все» ничего не изменит. */
  get hasAllPlatformsSelected(): boolean {
    if (!this.platformOptionsForFilter.length
      || this.selectedPlatforms.length !== this.platformOptionsForFilter.length) {
      return false;
    }
    const selected = new Set(this.selectedPlatforms.map((id) => String(id)));
    return this.platformOptionsForFilter.every((platform) => selected.has(String(platform.id)));
  }

  get canSelectAllPlatforms(): boolean {
    return !this.platformsIsLoading
      && !this.platformOptionsLoading
      && this.platformOptionsForFilter.length > 0
      && !this.hasAllPlatformsSelected;
  }

  selectAllPlatforms() {
    if (!this.canSelectAllPlatforms) {
      return;
    }
    this.selectedPlatforms = this.platformOptionsForFilter.map((platform) => String(platform.id));
  }

  clearFilters() {
    if (this.selectedPlatforms.length === 1
      && String(this.selectedPlatforms[0]) === String(this.defaultPlatform)) {
      this.selectedSuppliers = [];
    } else if (this.defaultPlatform) {
      this.selectedPlatforms = [String(this.defaultPlatform)];
    } else {
      this.selectedPlatforms = [];
    }
    this.enforceSupplierAutoFilter();
    this.idsFilter = '';
    this.setToStorage('ids', this.idsFilter);
    this.$bus.$emit('clear-filters');
    /** Программная смена полей не всегда даёт @input у ID; даты сбрасываются асинхронно через DateRange. */
    this.invalidateSheetsListAfterFilterChange();
    this.clearAppliedListStateInSession();
  }
}

